// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import moment from 'moment'
import store from './store'
import './services/axios'
import './services/message'
import './services/static-content-loader'
import VueTouch from 'vue-touch'

Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(VueTouch, {name: 'v-touch'})

Vue.filter('truncate', function (value, length, omission) {
  let _length = length ? parseInt(length, 10) : 20
  let _omission = omission ? omission.toString() : '...'

  if (value.length <= _length) {
    return value
  } else {
    return value.substring(0, length) + _omission
  }
})
Vue.filter('dateFormat', function (date, format) {
  let _format = format ? format.toString() : 'YYYY.MM.DD（ddd）HH:mm'
  try {
    moment.locale('ja')
    return moment(date).isValid() ? moment(date).format(_format) : ''
  } catch (e) {
    return ''
  }
})
Vue.filter('joinStrList', function (strList, delimiter) {
  if (strList == null) {
    return strList
  }
  return strList.join(delimiter != null ? delimiter : '、')
})
Vue.filter('unescapeHTML', function (str) {
  return str.replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&amp;/g, '&')
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
